/*
 * IMT only (divergence 07, parity/DIFFERENCES/07-delivery-cost-centres.md):
 * the bell items about the cost centre a new delivery creates. Each one
 * carries an action_url (backend: invoicing/services/delivery_cost_centre_service.py)
 * and opens it directly -- the approval request lands on the Cost Centres
 * screen focused on that cost centre (?waiting=1#cc-<id>), a failure on the
 * Cost Centres screen, a rejection on the delivery it was made for.
 *
 * One list for the navbar bell and the notifications page, so both open the
 * same place.
 */
export const COST_CENTRE_BELL_TYPES = Object.freeze([
  'cost_centre_approval_request',
  'cost_centre_rejected',
  'cost_centre_creation_failed',
]);

/** Where a cost-centre bell item opens, or null when it is some other bell. */
export const costCentreBellTarget = (notification) => (
  notification
  && COST_CENTRE_BELL_TYPES.includes(notification.notification_type)
  && notification.action_url
) || null;
